import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Stack, Typography, TextField, InputAdornment } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { discountGroupObjects } from "../data";

let selectedSchemeType = "";
function DiscountValueSection({ value, setValue, disable, handleFinalSummary, setFinalSummary }) {
	
	const [discounts, setDiscounts] = useState(value.discount_value || []);

	useEffect(() => {
		setDiscounts(value.discount_value || []);
	}, [value])

	const columns = [
		{
			field: "buy",
			headerName: "BUY",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "get",
			headerName: "GET",
			editable: true,
			type: "number",
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "actions",
			headerName: "Actions",
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<Button variant="outlined" color="error" size="small" onClick={() => handleDeleteRow(params.row.id)}>
					Delete
				</Button>
			),
			width: 100,
			align: "center",
			headerAlign: "center",
		},
	];

	const handleAddRow = () => {
		const newId = discounts.length ? discounts[discounts.length - 1].id + 1 : 1;
		const newRow = { id: newId, buy: 0, get: 0, percent: 0, value: 0 };
		const updated = [...discounts, newRow];
		setValue((prev) => ({ ...prev, discount_value: updated }));
		setDiscounts(updated);
	};

	const handleDeleteRow = (idToDelete) => {
		const updated = discounts.filter((row) => row.id !== idToDelete);
		setDiscounts(updated);
		setValue((prev) => ({ ...prev, discount_value: updated }));
	};

	const handleRowUpdate = (newRow) => {
		const updatedRows = discounts.map((row) => (row.id === newRow.id ? { ...row, buy: newRow.buy, get: newRow.get } : row));

		setDiscounts(updatedRows);
		setValue((prev) => ({
			...prev,
			discount_value: updatedRows,
		}));

		return newRow; // required by DataGrid
	};
	if (selectedSchemeType !== value[discountGroupObjects.general_information.key]?.scheme_type) {
		selectedSchemeType = value[discountGroupObjects.general_information.key]?.scheme_type;
		setValue((prev) => ({
			...prev,
			discount_value: [],
		}));
		setDiscounts([])
		setFinalSummary([])
	};

	const handleSingleFieldChange = (e) => {
		const inputValue = e.target.value;

		setValue((prev) => {
			const discountKey = discountGroupObjects.discount_value.key;
			const generalKey = discountGroupObjects.general_information.key;

			const prevTable = prev[discountKey]?.discount_table || [];
			const schemeType = prev[generalKey]?.scheme_type;

			return {
			...prev,
			[discountKey]: [
				...prevTable,

 {
				id: prevTable.length + 1,
				buy: 0,
				get: 0,
				percent:
					schemeType === "Flat_Discount_%"
					? inputValue
					: 0,
				value:
					schemeType === "Flat_Discount_Value"
					? inputValue
					: 0,

			}],
			};
		});
		};

	const renderContent = () => {
		if (value[discountGroupObjects.general_information.key]?.scheme_type === "Flat_Discount_%") {
			return (
				<TextField
					fullWidth
					label="Flat % Discount"
					type="number"
					value={value[discountGroupObjects.discount_value.key]?.[0]?.percent || ""}
					onChange={handleSingleFieldChange}
					InputProps={{
						endAdornment: <InputAdornment position="end">%</InputAdornment>,
					}}
				/>
			);
		} else if (value[discountGroupObjects.general_information.key]?.scheme_type === "Flat_Discount_Value") {
			return (
				<TextField
					fullWidth
					label="Flat ₹ Discount"
					type="number"
					value={value[discountGroupObjects.discount_value.key]?.[0]?.value || ""}
					onChange={handleSingleFieldChange}
					InputProps={{
						endAdornment: <InputAdornment position="end">₹</InputAdornment>,
					}}
				/>
			);
		} else {
			return (
				<>
					<Stack direction="row" justifyContent="flex-end" alignItems="center" mb={1} columnGap={2}>
						{/* <Typography variant="h6">Scheme Discount Slab</Typography> */}
						<Button variant="contained" onClick={handleAddRow} disabled={disable}>
							Add Row
						</Button>
					</Stack>
					<Divider sx={{ mb: 2 }} />
					<Stack maxHeight={300}>
						<DataGrid
							rows={discounts}
							columns={columns}
							disableColumnMenu
							hideFooter
							processRowUpdate={handleRowUpdate}
							experimentalFeatures={{ newEditingApi: true }}
							maxHeight={100}
						/>

					</Stack>
				</>
			);
		}
	};

	return (
		<Box width="95%" p={"1, 2"}>
			{/* <Typography variant="h6" mb={2}>
				Discount Value
			</Typography> */}
			{renderContent()}
			{/* <Button variant="contained" onClick={handleFinalSummary} disabled={disable} sx={{display:"flex", marginLeft:"auto", mt:1}}>
				Done
			</Button> */}
		</Box>
	);
}

export default DiscountValueSection;
